import React, { useState } from 'react'; // Importing React and the useState hook to manage component state.
import { Link } from 'react-router-dom'; // Importing the Link component for navigation (to create links to different routes).
import { Button } from 'react-bootstrap'; // Importing Button from React-Bootstrap for easy UI styling of buttons.
import { AiOutlineFileAdd } from "react-icons/ai"; // Importing a file add icon from React Icons for UI.
import { BsPencilFill } from "react-icons/bs"; // Importing a pencil icon (filled) for editing.
import { BsFileEarmarkCode } from "react-icons/bs"; // Importing a file icon (with code) from React Icons.
import { LuFilter } from 'react-icons/lu'; // Importing the filter icon from the Lu (Lucide) icon library.
import { GrAttachment, GrInbox } from "react-icons/gr"; // Importing attachment and inbox icons from Gr (Grommet) icon library.
// import Filter from '../../screens/cases/Filter.js'; // Importing a custom Filter component for filtering data in the UI.
import { useEffect } from 'react'; // Importing useEffect to manage side effects in the component (e.g., fetching data from an API).
import { IoSettingsOutline } from "react-icons/io5"; // Importing a settings icon (outline version) from React Icons.
import axios from "axios"; // Importing axios to make HTTP requests, commonly used for fetching data from APIs.
import Footer from './../../../footer';
import Header from './../../../header/header';
import Navvbar from './../../../header/Navvbar';



const UndeliverableCases = () => {
  // State to hold the list of cases fetched from the API
  const [cases, setCases] = useState([]);

  // State to manage the visibility of dropdowns for each case
  const [dropdownVisible, setDropdownVisible] = useState(null);

  // Get the current month and year to filter cases
  const [currentMonth] = useState(new Date().getMonth());  // Current month (0-indexed)
  const [currentYear] = useState(new Date().getFullYear()); // Current year (full year)

  // State to control modal visibility (e.g., for filters)
  const [show, setShow] = useState(false); 

  // Filter cases to only show those that belong to the current month and year
  const filteredCases = cases.filter((caseItem) => {
    const caseDate = new Date(caseItem.date); // Convert case date to Date object
    return caseDate.getMonth() === currentMonth && caseDate.getFullYear() === currentYear;
  });

  // Fetch cases from the API on component mount
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const res = await fetch("https://hms.backend.hiragroupcloud.com/api/cases"); // Make API call to fetch cases
        const data = await res.json(); // Parse the response data as JSON
        
        setCases(data);  // Save the fetched cases to the state
      } catch (error) {
        console.error("Error fetching cases:", error); // Handle error if API fails
      }
    };

    fetchCases();
  }, []);  // Empty dependency array means this effect runs only once after the first render

  // Clean up function to remove modal from DOM when component unmounts
  useEffect(() => {
    return () => {
      const modal = document.getElementById("modal"); // Get the modal element
      if (modal) {
        modal.remove();  // Remove the modal from the DOM when the component unmounts
      }
    };
  }, []);  // Empty array means this effect runs only when the component unmounts

  // Fetch cases again using axios (This block duplicates the previous fetch, you can remove one of them)
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await axios.get("https://hms.backend.hiragroupcloud.com/api/cases"); // API call using axios
        setCases(response.data); // Assuming `response.data` contains an array of case objects
      } catch (error) {
        console.error("Error fetching cases:", error); // Handle error if API fails
      }
    };

    fetchCases();
  }, []);  // Empty dependency array means this effect runs only once on component mount

  // Function to toggle the visibility of the dropdown for a specific case
  const toggleDropdown = (caseId) => {
    setDropdownVisible(dropdownVisible === caseId ? null : caseId); // Toggle dropdown visibility for selected case
  };

  // Show the modal when the filter button is clicked
  const handleShowModal = () => {
    setShow(true); // Set modal visibility to true
  };

  // Close the modal
  const handleCloseModal = () => {
    setShow(false); // Set modal visibility to false
  };
  return (
    <>
      <Header />
      <Navvbar/>
      <div style={{ marginTop: '20px', width: '95%', margin: '0 auto', padding: "0px" }}>
  {/* Header Section */}
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
    <h2 className="title" style={{ margin: 0, backgroundColor: "white" }}>
      Undeliverable Cases (£ 0.00)
    </h2>
  </div>

  {/* Button to Show Filters */}
  <div className="col-md-0 d-flex justify-content-end">
    <button
      style={{
        padding: '5px',
        backgroundColor: '#004aad',
        color: 'white',
        width: '90px',
        height: '35px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
      }}
      onClick={handleShowModal}
    >
      <LuFilter /> Filters
    </button>
  </div>

  <br />
  <br />

  {/* Table Wrapper */}
  <div
    style={{
      width: "100%",
      margin: "0 auto",
      padding: "20px",
      border: "3px solid #f4f4f4",
      borderRadius: "5px",
    }}
  >
    {/* Table for displaying cases */}
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          {/* Checkbox Column */}
          <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>
            <input type="checkbox" />
          </th>
          {/* Table headers with icons for Inbox and Attachment */}
          {[
            "Inbox", "Attachment", "Case/Pan", "Invoice", "Account", "Provider", 
            "Patient/Appt", "Lab Ship", "Account Ship", "Delivery Date",
          ].map((header) => (
            <th
              key={header}
              style={{
                padding: "10px",
                textAlign: "left",
                borderBottom: "1px solid #ddd",
                fontWeight: "bold",
              }}
            >
              {header === "Inbox" ? (
                <GrInbox style={{ fontSize: "20px" }} />
              ) : header === "Attachment" ? (
                <GrAttachment style={{ fontSize: "20px" }} />
              ) : (
                header
              )}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {/* Map through filtered cases and display them */}
        {filteredCases.length > 0 ? (
          filteredCases.map((caseItem) => (
            <tr
              key={caseItem._id}
              style={{ borderBottom: "1px solid #ddd", cursor: "pointer" }}
            >
              {/* Checkbox */}
              <td>
                <input type="checkbox" />
              </td>

              {/* Inbox Icon */}
              <td>
                <GrInbox style={{ fontSize: "20px" }} />
              </td>

              {/* Attachment Icon */}
              <td>
                <GrAttachment style={{ fontSize: "20px" }} />
              </td>

              {/* Case Details */}
              <td style={{ padding: "10px", textAlign: "left", position: "relative" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Case Number and Settings Button */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Link
                        to={`/case/${caseItem.caseNumber}`}
                        style={{
                          textDecoration: "none",
                          color: "#004aad",
                          fontSize: "17px",
                        }}
                      >
                        #{caseItem.caseNumber}
                      </Link>

                      {/* Settings Dropdown Toggle */}
                      <button
                        style={{
                          fontSize: "18px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          padding: 0,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown(caseItem._id);
                        }}
                      >
                        <IoSettingsOutline style={{ color: "#004aad", fontSize: "22px" }} />
                      </button>
                    </div>

                    {/* Pan Color */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <p style={{ margin: 0 }}>Pan Color:</p>
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: caseItem.color ? caseItem.color.toLowerCase() : "#ccc",
                          display: "inline-block",
                          borderRadius: "3px",
                        }}
                      ></span>
                      <span>{caseItem.color || "N/A"}</span>
                    </div>

                    {/* Quill Editor Content */}
                    <div
                      style={{ fontSize: "14px" }}
                      dangerouslySetInnerHTML={{ __html: caseItem.editorHtml }}
                    ></div>
                  </div>
                </div>

                {/* Dropdown Menu for Settings */}
                {dropdownVisible === caseItem._id && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "5px",
                      zIndex: 1000,
                      width: "150px",
                      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <ul style={{ listStyle: "none", padding: "0" }}>
                      <li style={{ padding: "8px 0", cursor: "pointer" }}>
                        <BsFileEarmarkCode /> Close/Invoice
                      </li>
                      <li style={{ padding: "8px 0", cursor: "pointer" }}>
                        <BsPencilFill /> Add Notes
                      </li>
                      <li style={{ padding: "8px 0", cursor: "pointer" }}>
                        <AiOutlineFileAdd /> Upload Files
                      </li>
                    </ul>
                  </div>
                )}
              </td>

              {/* Invoice Number */}
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.invoiceNumber || "N/A"}
              </td>

              {/* Account Holder */}
              <td style={{ padding: "10px", textAlign: "left" }}>
                <Link
                  to="/TabsWorking"
                  style={{
                    textDecoration: "none",
                    color: "#004aad",
                    fontSize: "16px",
                  }}
                >
                  {caseItem.account_holder || "N/A"}
                </Link>
              </td>

              {/* Provider Name */}
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.provider_name || "N/A"}
              </td>

              {/* Last Name */}
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.last_name || "N/A"}
              </td>

              {/* Dynamic Dates */}
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.start_date ? new Date(caseItem.start_date).toLocaleDateString() : "N/A"}
              </td>
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.arrive_date ? new Date(caseItem.arrive_date).toLocaleDateString() : "N/A"}
              </td>
              <td style={{ padding: "10px", textAlign: "left" }}>
                {caseItem.date ? new Date(caseItem.date).toLocaleDateString() : "N/A"}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
              No cases available.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  <br />

  {/* Pagination Buttons */}
  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '100%' }}>
    <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">First</Button>
    <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Previous</Button>
    <Button style={{ backgroundColor: "#004aad", borderColor: "#004aad", flex: 1, marginRight: "0", borderRadius: '0' }} className="mx-0">1</Button>
    <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Next</Button>
    <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Last</Button>
  </div>
</div>


      {/* Render gray background overlay when modal is visible */}
{show && (
  <div
    style={{
      position: 'fixed', // Position the overlay fixed on the screen
      top: 0, // Place it at the top of the viewport
      left: 0, // Place it at the left of the viewport
      width: '100%', // Full width of the screen
      height: '100%', // Full height of the screen
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent dark background (gray overlay)
      zIndex: 999, // Ensure it's on top of other content (like the modal)
    }}
    onClick={handleCloseModal} // Close the modal if the user clicks on the overlay
  />
)}

{/* Render the FilterModal component */}
{/* <Filter show={show} handleClose={handleCloseModal} /> */}

{/* Footer Section */}
<div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
  <Footer />
</div>

    </>
  );
};

export default UndeliverableCases ;
